import './FormField.scss';
import Icon from '../Icon/Icon';
import { useState } from 'react';
import React from 'react';
import { capitalizeFirstLetter } from '../../utils/string';
interface FormFieldProps {
  name?: string;
  label?: string;
  inputMode?: string;
  type?: string;
  placeholder?: string;
  register?: any;
  touchedFields?: any;
  disabled?: boolean;
  error?: any;
  prefix?: boolean;
  sufix?: boolean;
  labelSufix?: string;
  maxLength?: string;
  autofocus?: boolean;
  labelPrefix?: string;
  iconSufix?: string;
  iconPrefix?: string;
  customClass?: string;
  autocomplete?: string;
  isPassword?: boolean;
  shouldCapitalizeFirstLetter?: boolean;
  onKeyUp?: (e: React.FormEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FormEvent<HTMLInputElement>) => void;
  onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
}

export default function FormField({
  name = '',
  iconPrefix,
  labelPrefix,
  sufix,
  labelSufix,
  iconSufix,
  autofocus,
  maxLength = '200',
  register,
  touchedFields,
  placeholder = '',
  type = 'text',
  inputMode = 'text',
  error = {},
  customClass = '',
  autocomplete,
  disabled,
  isPassword,
  shouldCapitalizeFirstLetter = true,
  onKeyUp,
  onKeyDown,
  onBlur,
  onInput,
  label,
  ...props
}: FormFieldProps) {
  const [visibleIconPassword, setVisibleIconPassword] = useState(false);

  function mountPrefix() {
    if (iconPrefix || labelPrefix) {
      return (
        <div
          className={`form-field-prefix ${iconPrefix === 'personId' && 'transparent'}`}
        >
          {iconPrefix ? <Icon name={iconPrefix} /> : false}
          {labelPrefix}
        </div>
      );
    }

    return false;
  }

  function mountSufix() {
    if (sufix) {
      return (
        <div
          className="form-field-sufix"
          onClick={() =>
            isPassword ? setVisibleIconPassword((state) => !state) : false
          }
        >
          {iconSufix && !isPassword ? <Icon name={iconSufix} /> : false}
          {isPassword ? (
            <Icon name={visibleIconPassword ? 'eyeClose' : 'eye'} />
          ) : (
            false
          )}
          {labelSufix}
        </div>
      );
    }

    return false;
  }

  return (
    <>
      {label && (
        <label className="form-field-label" htmlFor={name}>
          {label}
        </label>
      )}

      <div
        className={
          `form-field ${customClass} ` +
          (disabled ? ' field-disabled' : '') +
          (error[name] && !disabled && !!touchedFields[name]
            ? ' input-error'
            : '')
        }
      >
        {mountPrefix()}

        <input
          id={name}
          className="caption"
          autoFocus={autofocus}
          {...register}
          disabled={disabled}
          type={isPassword && visibleIconPassword ? 'text' : type}
          placeholder={
            shouldCapitalizeFirstLetter
              ? capitalizeFirstLetter(placeholder)
              : placeholder
          }
          inputMode={inputMode}
          onBlurCapture={onBlur}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          onInput={onInput}
          maxLength={maxLength}
          autoComplete={autocomplete}
          {...props}
        />
        {mountSufix()}
      </div>
    </>
  );
}

// ex: Implementation
{
  /* <FormField label="email" placeHolder="Preencha seu email" type="email" />
      or
     <FormField
        prefix
        labelPrefix="+ 55"
        iconPrefix="flagBrasil"
        label="phone"
        placeHolder="Preencha seu telefone"
        type="text"/>
  */
}
